import React from "react";
import { EagerProcessor } from "./SpecsEditorImagePanels";
import { useSpecsEditorContextValue } from "./useSpecsEditor";
import type { OutputImage } from "./types";

export default function SpecsEditorLayers() {
  const {
    editor: { session, setProcessedImageUrl },
  } = useSpecsEditorContextValue();

  return (
    <>
      {Object.values(session.layerRuntimeByKey)
        .filter((layer) => layer.visible)
        .flatMap((layer) => {
          const images: { img: OutputImage; side: string }[] = [];
          if (
            layer.mask &&
            !layer.mask.outputImageUrl &&
            layer.mask.sourceLayerId
          ) {
            images.push({ img: layer.mask, side: "front" });
          }
          if (
            layer.highlight &&
            !layer.highlight.outputImageUrl &&
            layer.highlight.sourceLayerId
          ) {
            images.push({ img: layer.highlight, side: "front" });
          }
          return images;
        })
        .map(({ img, side }) => (
          <EagerProcessor
            key={img.id}
            outputImage={img}
            inputLayers={session.input?.layers ?? []}
            onProcessed={setProcessedImageUrl}
            side={side}
          />
        ))}
    </>
  );
}
